/**
 * Convert Unix timestamp (seconds) to Date
 */
export const fromUnixTimestamp = (timestamp: number): Date => {
  return new Date(timestamp * 1000);
};
